import { UIIcon } from '../config/icons';
import { ABPaymentDialog } from '../lib/ab/payment';
import { homeMakeNewPlanCard } from '../lib/ab/plan-card';
import { ABScreen } from '../lib/ab/screen';
import { showLoader } from '../lib/ab/widgets';
import { aTrackClick, aTrackPage } from '../lib/mdl/a-track';
import { c_cities } from '../lib/mdl/c-city';
import { CHEvent } from '../lib/mdl/c-event-home';
import { CPlan } from '../lib/mdl/c-plan';
import { CAccountStatus, CLoginUser, CPaidPlanId } from '../lib/mdl/c-user';
import { ELegacyPaymentMethodDescription, eLegacyPaymentMethodDescription } from '../lib/mdl/e-payment-method';
import { EUserTransactionHomeView } from '../lib/mdl/e-user-transaction';
import { LegacyMembershipInfo, TLActionChangePlanInfo, TLActionSubscribeInfo, TLActionUnsubscribeInfo } from '../lib/mdl/zzz-legacy-user';
import { meAction, meGetInfo } from '../lib/me/home';
import { the_alt_token, the_user } from '../lib/me/login';
import { getCountry } from '../lib/me/me';
import { UIButton } from '../lib/ui/component/button';
import { UIDialog } from '../lib/ui/component/dialog';
import { UITextInput } from '../lib/ui/component/input';
import { UISegmented } from '../lib/ui/component/segmented';
import { UITable, UITableDefinition } from '../lib/ui/component/table';
import { uiToast } from '../lib/ui/component/toast';
import { $el } from '../lib/ui/elements';
import { $fmt } from '../lib/ui/fmt';
import { uiLock } from '../lib/ui/functions';
import { UIViewSpec } from '../lib/ui/view';
import { $amount } from '../lib/y/amount';
import { $analytics } from '../lib/y/analytics';
import { $cdn } from '../lib/y/cdn';
import { YArrayDataSource } from '../lib/y/data-source';
import { $on } from '../lib/y/events';
import { $format } from '../lib/y/format';
import { $i18n, yGetI18N, yInterpolate } from '../lib/y/i18n';
import { $location } from '../lib/y/location';
import { $time, YTime } from '../lib/y/time';
import { HomeMenu } from './menu';

class CancelDialog extends UIDialog {
    constructor(info?: TLActionUnsubscribeInfo) {
        super({ close: true, classes: 'm-550' });

        const block = $el.DIV('w-block l-form m-center', [
            $el.H2('title', $i18n.tl.h_cancel_dialog),
        ]);

        if(info) {
            block.ui_add($el.P('info', $i18n.tl.t_cancel_dialog_1 + ' ' + $time(info.cancel_date).format('d MMM yyyy')));

            //TODOURGENT
            // if(info.bookings.length) {
            //     block.ui_add([
            //         $el.DIV('s-small'),
            //         $el.H3('heading', $i18n.tl.t_cancel_dialog_unbook), 
            //         $el.UL(info.bookings.map(b => b.event_name + ', ' + $time(b.session_time).format('d MMM yyyy')), 'tl-pause-bookings'),
            //         $el.DIV('s-medium')
            //     ]);
            // } else {
            block.ui_add($el.DIV('s-small'));
            // }
        } else {
            block.ui_add($el.P('info', $i18n.tl.t_cancel_dialog_2))
        }

        const reason = new UITextInput({ lines: 3 });

        block.ui_add([
            $el.P('info', $i18n.tl.t_cancel_dialog_comment),
            reason,
            $el.DIV('l-button-row', [
                new UIButton({
                    title: $i18n.tl.b_confirm, classes: 'ui-tint-reverse', on_click: () =>
                        meAction('unsubscribe', { notes: reason.value }).then(() => { this.dismiss(true) })
                })
            ])
        ]);

        this.content.ui_add(block);
    }
}

class PauseDialog extends UIDialog {
    constructor(info: TLActionUnsubscribeInfo, can_unsubscribe: boolean) {
        super({ close: true, classes: 'm-550' });

        const block = $el.DIV('w-block l-form m-center', [
            $el.H2('title', $i18n.tl.h_pause_dialog),
            $el.P('input-hint', $i18n.tl.t_pause_dialog),
        ]);

        //TODOURGENT
        // if(info.bookings.length) {
        //     block.ui_add([
        //         $el.DIV('s-small'),
        //         $el.H3('heading', $i18n.tl.t_cancel_dialog_unbook), 
        //         $el.UL(info.bookings.map(b => b.event_name + ', ' + $time(b.session_time).format('d MMM yyyy')), 'tl-pause-bookings'),
        //         $el.DIV('s-medium')
        //     ]);
        // }

        const next_date_span = $el.SPAN();

        const months = new UISegmented([{ key: 1, name: '1' }, { key: 2, name: '2' }, { key: 3, name: '3' }], { classes: 'm-flexible m-light-border' });
        $on(months, 'value', v => { next_date_span.textContent = $time(info.pause_date).add(v!, $time.month).format('d MMM yyyy') });
        months.value = 1;

        block.ui_add([
            $el.P('subheading', $i18n.tl.t_pause_choose_months),
            months,
            $el.P('info', [$i18n.tl.t_membership_next_billing + '\u00a0', next_date_span]),
            $el.DIV('s-small'),
            $el.DIV('l-button-row', [
                new UIButton({
                    title: $i18n.tl.b_confirm, classes: 'ui-tint-reverse', on_click: () => {
                        const n_months = months.value!
                        return meAction('pause', { months: n_months }).then(() => { this.dismiss(true) });
                    }
                })
            ]),
            can_unsubscribe && new UIButton({
                kind: 'k-text', classes: 'm-small', title: $i18n.tl.t_pause_dialog_unsubscribe, right_icon: UIIcon.ARROW_RIGHT, on_click: () => {
                    this.dismiss(new CancelDialog(info).present({ replace: this }));
                }
            })
        ]);

        this.content.ui_add(block);
    }
}

class CancelPauseDialog extends UIDialog {
    constructor() {
        super({ close: true, classes: 'm-550' });

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', $i18n.tl.h_cancel_dialog),
            $el.P('input-hint', $i18n.tl.t_cancel_dialog_pause),
            $el.DIV('s-small'),
            $el.DIV('l-button-row', [
                new UIButton({ title: $i18n.tl.b_cancel, classes: 'ui-tint-reverse m-hollow', on_click: () => { this.dismiss(null) } }),
                new UIButton({
                    title: $i18n.tl.b_extend_pause, classes: 'ui-tint-reverse', on_click: () =>
                        meAction('pause', { months: 1 }).then(() => {
                            $analytics.track('Pause extended', { months: 1 });
                            this.dismiss(true);
                        })
                })
            ]),
            new UIButton({
                kind: 'k-text', classes: 'm-small', title: $i18n.tl.t_pause_dialog_unsubscribe, right_icon: UIIcon.ARROW_RIGHT, on_click: () => {
                    this.dismiss(new CancelDialog().present({ replace: this }));
                }
            })
        ]));
    }
}

class ExtendPauseDialog extends UIDialog {
    constructor(date: YTime) {
        super({ close: true, classes: 'm-550' });

        const next_date_span = $el.SPAN();

        const months = new UISegmented([{ key: 1, name: '1' }, { key: 2, name: '2' }, { key: 3, name: '3' }], { classes: 'm-flexible m-light-border' }); // TODO: check if we really want m-light-border
        $on(months, 'value', v => { next_date_span.textContent = date.add(v!, $time.month).format('d MMM yyyy') });
        months.value = 1;


        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', $i18n.tl.h_extend_pause),
            $el.P('input-hint', $i18n.tl.t_pause_choose_months),
            months,
            $el.P('info', [$i18n.tl.t_membership_next_billing + '\u00a0', next_date_span]),
            $el.DIV('s-small'),
            $el.DIV('l-button-row', [
                new UIButton({ title: $i18n.tl.b_cancel, classes: 'ui-tint-reverse m-hollow', on_click: () => { this.dismiss(null) } }),
                new UIButton({
                    title: $i18n.tl.b_confirm, classes: 'ui-tint-reverse', on_click: () => {
                        const n_months = months.value!
                        meAction('pause', { months: n_months }).then(() => {
                            $analytics.track('Pause extended', { months: n_months });
                            this.dismiss(true);
                        });
                    }
                })
            ])
        ]));
    }
}

// TODO: see if we still have the option of booking an event at the same time
class ChangePlanDialog extends UIDialog {
    constructor(info: TLActionChangePlanInfo, event?: CHEvent) {
        super({ close: true, classes: 'm-550' });

        const block = $el.DIV('w-block', [
            $el.H2('title', $i18n.tl.h_change_plan_dialog)
        ]);

        const option = info.options[0];

        if(event) {
            block.ui_add([
                $el.P('text', $i18n.tl.t_changeplan_event_1),
                $el.P('text', $i18n.tl.t_changeplan_event_2),
                $el.P('text', $i18n.tl.t_changeplan_event_3),
                $el.P('text', $i18n.tl.t_changeplan_total + ' ' + $format.currency(option.price))
            ]);
        } else if(option.price.value > 0) {
            block.ui_add([
                $el.P('text', $i18n.tl.t_changeplan_upgrade_1),
                $el.P('text', yInterpolate($i18n.tl.t_changeplan_upgrade_2, $time(option.next_payment_date).format('d MMM yyyy'))),
                $el.P('text', $i18n.tl.t_changeplan_upgrade_3),
                $el.P('text', $i18n.tl.t_changeplan_total + ' ' + $format.currency(option.price))
            ]);
        } else {
            const date = $time(option.change_date).format('d MMM yyyy');

            block.ui_add([
                $el.P('text', yInterpolate($i18n.tl.t_changeplan_downgrade_1, date)),
                $el.P('text', yInterpolate($i18n.tl.t_changeplan_downgrade_2, date)),
                $el.P('text', yInterpolate($i18n.tl.t_changeplan_downgrade_3, date))
            ]);
        }

        block.ui_add([
            $el.DIV('s-medium'),
            $el.DIV('l-button-row', [
                new UIButton({
                    title: $i18n.tl.b_confirm, classes: 'ui-tint-reverse', on_click: () =>
                        meAction('change_plan', { plan: option.plan.id }).then(r => {
                            if(r === true) {
                                this.dismiss(true);
                                $location.reload();
                            } else {
                                new ABPaymentDialog(r, {
                                    finish: (model: CLoginUser) => {
                                        Object.assign(the_user!, model);
                                        $location.reload();

                                        // TODO: this
                                        // if(event) {
                                        //     availability!.max_tickets = 2;
                                        //     this.dismiss(new home_event.BookDialog(event, venue!, session!, '', availability!).present({ replace: this }));
                                        // } else {
                                        //     this.dismiss(true);
                                        // }
                                    }
                                }, { title: $i18n.tl.b_change_payment }).present({ replace: this });
                            }
                        })
                })
            ])
        ]);

        this.content.ui_add(block);
    }
}

class PickSubscriptionDialog extends UIDialog {
    constructor(info: TLActionSubscribeInfo, is_resubscribe: boolean) {
        super({ close: true, classes: 'm-mobile-fs' });

        const on_choose = (plan: CPaidPlanId) => {
            if(is_resubscribe) {
                this.dismiss(new ResubscribeDialog(info, plan).present({ replace: this }));
                return;
            } else {
                return uiLock(meAction('subscribe', { plan: plan }).then(r => {
                    if(r === true) {
                        this.dismiss(true);
                    } else {
                        const dialog = new ABPaymentDialog(r, {
                            finish: (model: CLoginUser) => {
                                Object.assign(the_user!, model);
                            }
                        }, { title: $i18n.tl.h_resubscribe_dialog, info: (info.dont_activate && r.amount.value == 0) ? $i18n.tl.t_signup_dont_activate_text : undefined });
                        this.dismiss(dialog.present({ replace: this }));
                    }
                }));
            }
        };

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', $i18n.tl.h_choose_membership),
            $el.DIV('blk-plans b b-content', window.ab_plans.map(p => homeMakeNewPlanCard('c-light', 'ui-tint-blue', p, info.new_promo, () => on_choose(p.id))))
        ]));
    }
}

class ResubscribeDialog extends UIDialog {
    constructor(info: TLActionSubscribeInfo, plan: CPaidPlanId) {
        super({ close: true, classes: 'm-550' });

        const city = c_cities.maybe(the_user!.city_id)!;

        this.content.ui_add($el.DIV('w-block l-form m-real-left', [
            $el.H2('subheading', $i18n.tl.resubscribe_popup_title),
            $el.P('text', yInterpolate($i18n.tl.resubscribe_popup_text, '' + window.ab_stats.active_sessions_city[city.id], city.name)),
            $el.DIV('s-medium'),
            $el.DIV('l-button-row', [
                new UIButton({
                    title: $i18n.tl.resubscribe_popup_button, classes: 'ui-tint-reverse', on_click: () =>
                        uiLock(meAction('subscribe', { plan: plan }).then(r => {
                            if(r === true) {
                                this.dismiss(true);
                            } else {
                                const dialog = new ABPaymentDialog(r, {
                                    finish: (model: CLoginUser) => {
                                        Object.assign(the_user!, model);
                                    }
                                }, { title: $i18n.tl.h_resubscribe_dialog, info: (info.dont_activate && r.amount.value == 0) ? $i18n.tl.t_signup_dont_activate_text : undefined });
                                this.dismiss(dialog.present({ replace: this }));
                            }
                        }))
                })
            ])
        ]));
    }
}

function makeTransactionDescription(tx: EUserTransactionHomeView) {
    if(!tx.items.length) return '-';

    if(tx.type === 'recurring' || tx.type === 'subscribe') {
        let description = $i18n.tl.td_payment_membership + ' ' + tx.items[0].description;
        for(let i = 1; i < tx.items.length; i++) {
            const item = tx.items[i];
            let name = item.description;
            if(item.type == 'addon') {
                let specific_name = $i18n.tl.td_payment_addons[item.code as 'late_cancel' | 'bonus'];
                if(specific_name)
                    name = specific_name;
            }

            if(item.amount.value < 0)
                description += '\n- ' + name + ' (' + $format.currency($amount.neg(item.amount)) + ')';
            else
                description += '\n+ ' + name + ' (' + $format.currency(item.amount) + ')';
        }
        return description;
    } else if(tx.type === 'purchase') {
        if(tx.items[0].type === 'session')
            return $i18n.tl.td_payment_tickets;
        else if(tx.items[0].type === 'giftcard')
            return $i18n.tl.td_payment_giftcard;
        else
            return tx.items[0].description;
    } else if(tx.type === 'change_plan') {
        return $i18n.tl.td_payment_upgrade;
    } else {
        return '-';
    }
}

function makeCreditCard(method: ELegacyPaymentMethodDescription, change_payment: () => void) {
    let card_name: UIViewSpec;
    const classes = ['tl-card k-credit'];
    let card_number: string | undefined;
    let exp = false;

    if(method.type == 'card') {
        if(method.card_type == 'Maestro') {
            card_name = $el.IMG($cdn('images/assets/cards/maestro.svg'));
            classes.push('m-black');
        } else if(method.card_type == 'MasterCard') {
            card_name = $el.IMG($cdn('images/assets/cards/mastercard.svg'));
            classes.push('m-white');
        } else if(method.card_type == 'Visa') {
            card_name = $el.IMG($cdn('images/assets/cards/visa.svg'));
            classes.push('m-white');
        } else if(method.card_type == 'American Express') {
            card_name = $el.IMG($cdn('images/assets/cards/amex.svg'));
            classes.push('m-black');
        } else {
            card_name = $el.DIV('r-title', method.card_type);
            classes.push('m-black');
        }

        card_number = 'XXXX XXXX XXXX ' + method.card_last4
        exp = true;
    } else if(method.type == 'paypal') {
        card_name = $el.DIV('r-title', 'Paypal');
        classes.push('m-black');
        card_number = method.email;
    } else if(method.type == 'account') {
        card_name = $el.DIV('r-title', method.bank);
        classes.push('m-black');
        card_number = 'XXXXXXXX ' + method.account
    } else {
        card_name = $el.DIV('r-title', method.type);
    }

    return $el.DIV(classes, $el.DIV('r-card', [
        card_name,
        card_number && $el.B(card_number),
        exp && $el.DIV('r-small', $i18n.tl.td_payment_valid_until + ' ' + method.exp_month + '/' + method.exp_year),
        $el.S(),
        new UIButton({ title: $i18n.tl.b_change_payment, classes: 'ui-tint-reverse', on_click: change_payment }),
        $el.S()
    ]));
}

function makeSubscriptionCard(status: CAccountStatus, plan: CPlan) {
    return $el.DIV('tl-card k-subscription c-light', $el.DIV('r-card', [
        $el.S(),
        $el.DIV('r-title', yGetI18N(plan.name)),
        $el.DIV('r-subtitle', $format.currency(plan.price[getCountry()])),
        $el.S(),
        status == 'active' && [
            new UIButton({
                title: $i18n.tl.b_change_plan, on_click: () =>
                    meGetInfo('change_plan').then(info => {
                        new ChangePlanDialog(info).present().then($location.reload);
                    })
            }),
            $el.S()
        ]
    ]));
}

export class HomeMembershipScreen extends ABScreen {
    constructor() {
        super({ menu: new HomeMenu({ classes: 'm-account' }) });
    }

    protected override fillContent(content: UIViewSpec): void {
        showLoader(content, meGetInfo('membership').then(info => {
            this._fill(content, info);
        }));

        aTrackPage('membership');
    }

    private _fill(content: UIViewSpec, info: LegacyMembershipInfo) {
        const section = $el.DIV('ui-section');
        content.ui_add(section);

        const left_col = $el.DIV('i-column m-540 l-form', $el.H3('heading', $i18n.tl.h_membership));
        const right_col = $el.DIV('i-column m-540 l-form');

        const recurring_info = info.recurring_info;
        const status = recurring_info.status;
        const subscription = info.subscription;
        const next_payment = $time(recurring_info.payment_date);
        const end_date = subscription && $time(subscription.end_date);
        const has_current_subscription = end_date && end_date.after($time.now());

        if(status == 'inactive') {
            if(has_current_subscription) {
                if(subscription.type == 'gc' || subscription.type == 'free') {
                    left_col.ui_add($el.DIV('tl-membership-box l-form', [
                        $el.B(yInterpolate($i18n.tl.t_membership_gc, end_date.format('d MMM yyyy'))),
                        new UIButton({
                            title: $i18n.tl.b_renew_subscription, classes: 'ui-tint-reverse', on_click: () => {
                                $location.navigate(['subscribe'], { origin: 'direct', resubscribe: true });
                            }
                        }),
                    ]));
                } else {
                    const last_book_date = end_date.add(-1, $time.day);

                    left_col.ui_add($el.DIV('tl-membership-box l-form', [
                        $el.B(yInterpolate($i18n.tl.t_membership_cancelled, last_book_date.format('d MMM yyyy'))),
                        new UIButton({
                            title: $i18n.tl.b_undo_cancel, classes: 'ui-tint-reverse', on_click: () =>
                                uiLock(meAction('subscribe', { plan: recurring_info.plan as CPaidPlanId }).then(r => {
                                    if(r === true) {
                                        $location.reload();
                                    } else {
                                        new ABPaymentDialog(r, {
                                            finish: (model: CLoginUser) => {
                                                Object.assign(the_user!, model);
                                                $location.reload();
                                            }
                                        }, { title: $i18n.tl.b_change_payment }).present();
                                    }
                                }))
                        })
                    ]));
                }
            } else {
                left_col.ui_add($el.DIV('tl-membership-box l-form', [
                    $el.B($i18n.tl.t_membership_none),
                    new UIButton({
                        title: subscription ? $i18n.tl.b_membership_resume : $i18n.tl.b_membership_choose, on_click: () => {
                            return uiLock(meGetInfo('subscribe').then(info => {
                                new PickSubscriptionDialog(info, !!subscription).present().then($location.reload);
                            }))
                        }
                    })
                ]));
            }
        } else {
            const changePayment = () => uiLock(meAction('change_payment').then(intent => {
                new ABPaymentDialog(intent, {
                    finish: (model: CLoginUser) => {
                        Object.assign(the_user!, model);
                        $location.reload();
                    }
                }, { title: $i18n.tl.b_change_payment }).present();
            }));

            if(status == 'paused' || status == 'active') {
                if(info.payment_method) {
                    right_col.ui_add([
                        $el.H3('heading', $i18n.tl.h_payment),
                        makeCreditCard(info.payment_method.description, changePayment),
                        $el.DIV('s-tiny')
                    ]);
                }

                const next_amount = info.next_payment_amount!;

                right_col.ui_add([
                    $el.H3('heading', $i18n.tl.t_membership_next_billing + '\u00a0'),
                    $el.P('text', next_payment.format('d MMM yyyy') + '\u00a0\u00a0\u00a0' + $format.currency(next_amount)),
                ]);
            }

            const action_buttons = $el.DIV('l-button-row m-left');

            left_col.ui_add([makeSubscriptionCard(status, info.plan!), $el.DIV('s-tiny'), action_buttons, $el.DIV('s-medium')]);

            if(status == 'pastdue') {
                right_col.ui_prepend($el.DIV('tl-membership-box l-form', [
                    $el.P('text', $i18n.tl.t_membership_pastdue),
                    !!next_payment.n && $el.P('text', "Vi kommer göra ett nytt försök att genomföra betalningen " + next_payment.format('d MMM yyyy') + '.'),
                    $el.P('text', "Dina biljetter riskerar att avbokas", 't-w-bold'),
                    new UIButton({ title: $i18n.tl.b_try_again, classes: 'ui-tint-reverse', on_click: changePayment })
                ]));
            }

            if(status == 'active' || status == 'pastdue') {
                action_buttons.ui_add([
                    info.payment_method && new UIButton({
                        title: $i18n.tl.b_pause, classes: 'ui-tint-reverse', on_click: () =>
                            uiLock(meGetInfo('unsubscribe').then(r => {
                                $analytics.track('Click pause');
                                aTrackClick('membership_pause');
                                new PauseDialog(r, false).present().then($location.reload);
                            }))
                    }),
                    new UIButton({
                        title: $i18n.tl.b_unsubscribe, classes: 'ui-tint-reverse', on_click: () =>
                            uiLock(meGetInfo('unsubscribe').then(r => {
                                $analytics.track('Click cancel');
                                aTrackClick('membership_unsubscribe');
                                if(info.payment_method)
                                    new PauseDialog(r, true).present().then($location.reload);
                                else
                                    new CancelDialog(r).present().then($location.reload);
                            }))
                    })
                ]);
            } else {
                let text: string;
                if(has_current_subscription)
                    text = yInterpolate($i18n.tl.t_membership_pauses, $time(info.subscription!.end_date).format('d MMM yyyy'));
                else
                    text = yInterpolate($i18n.tl.t_membership_paused, next_payment.format('d MMM yyyy'));

                left_col.ui_add($el.DIV('tl-membership-box l-form', [
                    $el.P('text', text),
                    $el.DIV('l-button-row m-left', [
                        new UIButton({
                            title: $i18n.tl.b_resume_now, classes: 'ui-tint-reverse', on_click: () =>
                                uiLock(meAction('unpause').then(r => {
                                    if(r === true) {
                                        $location.reload();
                                    } else {
                                        new ABPaymentDialog(r, {
                                            finish: (model: CLoginUser) => {
                                                Object.assign(the_user!, model);
                                                $location.reload();
                                            }
                                        }, { title: $i18n.tl.b_change_payment }).present();
                                    }
                                }))
                        }),
                        !has_current_subscription && next_payment.add(-14, $time.day).is_past && new UIButton({
                            title: $i18n.tl.b_extend_pause, classes: 'ui-tint-reverse', on_click: () => {
                                new ExtendPauseDialog(next_payment).present().then($location.reload);
                            }
                        })
                    ]),
                    $el.DIV('l-button-row m-left', [
                        new UIButton({
                            title: $i18n.tl.b_unsubscribe, classes: 'ui-tint-reverse', on_click: () => {
                                new CancelPauseDialog().present().then($location.reload);
                            }
                        })
                    ])
                ]));
            }
        }

        const gc_code = new UITextInput({ placeholder: $i18n.tl.ph_gc_code, autofill: 'giftcard-code' });

        left_col.ui_add([
            $el.DIV('s-medium'),
            $el.H3('heading', $i18n.tl.h_membership_have_gc),
            gc_code,
            $el.DIV('l-button-row m-left', [
                new UIButton({
                    title: $i18n.tl.b_enter_gc, classes: 'ui-tint-reverse', on_click: () =>
                        meAction('redeem_gc', { code: gc_code.value }).then($location.reload, uiToast)
                })
            ])
        ]);

        section.ui_add($el.DIV('l-columns w-block', [left_col, right_col]));

        const transactions = info.transactions.filter(e => e.type != 'redeem');

        if(transactions.length) {
            transactions.sort((a, b) => $time.compare($time(b.date), $time(a.date)));

            // TODO: fix for payment/refund combos
            const def = new UITableDefinition<EUserTransactionHomeView>();
            def.addValue(e => {
                const date = $time(e.date);
                let text = date.format('d MMM yyyy');
                if(e.payment_failed)
                    text += ' (' + $i18n.tl.td_payment_failed + ')';
                if(e.refund_transaction_id)
                    text += ' (' + $i18n.tl.td_payment_refund + ')';
                return text;
            }, { title: $i18n.tl.th_payment_date, width: 150, comparator: (a, b, o) => o * $time.compare($time(a.date), $time(b.date)) });
            def.addValue(makeTransactionDescription, { title: $i18n.tl.th_payment_description, width: 200, classes: 'm-pre' });
            def.addValue(e => e.payment_method ? eLegacyPaymentMethodDescription(e.payment_method) : '-', { title: $i18n.tl.th_payment_method, width: 160 });
            def.addValue(e => e.refund_transaction_id ? $amount.neg(e.amount) : e.amount, $fmt.CURRENCY, { title: $i18n.tl.th_payment_total, width: 80 });
            def.addButtons([
                {
                    icon: UIIcon.PAPERCLIP, tooltip: $i18n.tl.b_payment_receipt, when: e => !e.refund_transaction_id && !e.payment_failed,
                    link: e => ({
                        href: `/docs/user/${the_user!.id}/receipt/${e.id}?format=pdf&token=${the_alt_token}`,
                        download: 'Abundo kvitto - ' + $time(e.date).format('yyyy-MM-dd') + '.pdf'
                    })
                }
            ], { width: -30 });

            def.controller = row => {
                row.classList.add('tl-payment-info-row');
                if(row.item.payment_failed)
                    row.classList.add('m-failed');

                return undefined;
            }

            const invite = new UIButton({
                kind: 'k-text', classes: 'm-inline', title: $i18n.tl.b_invite_friends_here,
                on_click: () => { $location.navigate(['invite']) }
            });

            section.ui_add($el.DIV('w-block-1200 l-form', [
                $el.DIV('s-medium'),
                $el.H3('heading', $i18n.tl.h_payment_history),
                new UITable(def, new YArrayDataSource(transactions)),
                $el.P('text', [$i18n.tl.p_payment_history_bonus + ' ', invite], 'r-invite')
            ]));
        }
    }
}

// export class HomeNewMembershipScreen extends ABScreen {
//     constructor() {
//         super({ menu: new HomeMenu({ classes: 'm-account' }) });
//     }

//     protected override fillContent(content: UIViewSpec): void {
//         showLoader(content, meGetInfo('new_membership').then(info => {
//             this._fill(content, info);
//         }));

//         aTrackPage('membership');
//     }

//     private _fill(content: UIViewSpec, info: MEMembershipInfo) {
//         const section = $el.DIV('ui-section');
//         content.ui_add(section);

//         const left_col = $el.DIV('i-column m-540 l-form', $el.H3('heading', $i18n.tl.h_membership));
//         const right_col = $el.DIV('i-column m-540 l-form');

//         const status = info.recurring_status;
//         const subscription = info.subscription;
//         const next_payment = $time(info.payment_date);
//         const end_date = subscription && $date(subscription.end_date);
//         const has_current_subscription = end_date && end_date.start.after($time.now());

//         if(status == 'inactive') {
//             if(has_current_subscription) {
//                 if(subscription.type == 'gc' || subscription.type == 'free') {
//                     left_col.ui_add($el.DIV('tl-membership-box l-form', [
//                         $el.B(yInterpolate($i18n.tl.t_membership_gc, end_date.format('d MMM yyyy'))),
//                         new UIButton({
//                             title: $i18n.tl.b_renew_subscription, classes: 'ui-tint-reverse', on_click: () => {
//                                 $location.navigate(['subscribe'], { origin: 'direct', resubscribe: true });
//                             }
//                         }),
//                     ]));
//                 } else {
//                     const last_book_date = end_date.add(-1, $time.day);

//                     left_col.ui_add($el.DIV('tl-membership-box l-form', [
//                         $el.B(yInterpolate($i18n.tl.t_membership_cancelled, last_book_date.format('d MMM yyyy'))),
//                         new UIButton({
//                             title: $i18n.tl.b_undo_cancel, classes: 'ui-tint-reverse', on_click: () =>
//                                 uiLock(meAction('subscribe', { plan: info.plan as CPaidPlanId }).then(r => {
//                                     if(r === true) {
//                                         $location.reload();
//                                     } else {
//                                         new ABPaymentDialog(r, {
//                                             finish: (model: CLoginUser) => {
//                                                 Object.assign(the_user!, model);
//                                                 $location.reload();
//                                             }
//                                         }, { title: $i18n.tl.b_change_payment }).present();
//                                     }
//                                 }))
//                         })
//                     ]));
//                 }
//             } else {
//                 left_col.ui_add($el.DIV('tl-membership-box l-form', [
//                     $el.B($i18n.tl.t_membership_none),
//                     new UIButton({
//                         title: subscription ? $i18n.tl.b_membership_resume : $i18n.tl.b_membership_choose, on_click: () => {
//                             return uiLock(meGetInfo('subscribe').then(info => {
//                                 new PickSubscriptionDialog(info, !!subscription).present().then($location.reload);
//                             }))
//                         }
//                     })
//                 ]));
//             }
//         } else {
//             const changePayment = () => uiLock(meAction('change_payment').then(intent => {
//                 new ABPaymentDialog(intent, {
//                     finish: (model: CLoginUser) => {
//                         Object.assign(the_user!, model);
//                         $location.reload();
//                     }
//                 }, { title: $i18n.tl.b_change_payment }).present();
//             }));

//             if(status == 'paused' || status == 'active') {
//                 if(info.payment_method) {
//                     right_col.ui_add([
//                         $el.H3('heading', $i18n.tl.h_payment),
//                         makeCreditCard(info.payment_method.description, changePayment),
//                         $el.DIV('s-tiny')
//                     ]);
//                 }

//                 const next_amount = info.next_payment_amount!;

//                 right_col.ui_add([
//                     $el.H3('heading', $i18n.tl.t_membership_next_billing + '\u00a0'),
//                     $el.P('text', next_payment.format('d MMM yyyy') + '\u00a0\u00a0\u00a0' + $format.currency(next_amount)),
//                 ]);
//             }

//             const action_buttons = $el.DIV('l-button-row m-left');

//             left_col.ui_add([makeSubscriptionCard(status, info.plan!), $el.DIV('s-tiny'), action_buttons, $el.DIV('s-medium')]);

//             if(status == 'pastdue') {
//                 right_col.ui_prepend($el.DIV('tl-membership-box l-form', [
//                     $el.P('text', $i18n.tl.t_membership_pastdue),
//                     !next_payment.is_zero && $el.P('text', "Vi kommer göra ett nytt försök att genomföra betalningen " + next_payment.format('d MMM yyyy') + '.'),
//                     $el.P('text', "Dina biljetter riskerar att avbokas", 't-w-bold'),
//                     new UIButton({ title: $i18n.tl.b_try_again, classes: 'ui-tint-reverse', on_click: changePayment })
//                 ]));
//             }

//             if(status == 'active' || status == 'pastdue') {
//                 action_buttons.ui_add([
//                     info.payment_method && new UIButton({
//                         title: $i18n.tl.b_pause, classes: 'ui-tint-reverse', on_click: () =>
//                             uiLock(meGetInfo('unsubscribe').then(r => {
//                                 $analytics.track('Click pause');
//                                 aTrackClick('membership_pause');
//                                 new PauseDialog(r, false).present().then($location.reload);
//                             }))
//                     }),
//                     new UIButton({
//                         title: $i18n.tl.b_unsubscribe, classes: 'ui-tint-reverse', on_click: () =>
//                             uiLock(meGetInfo('unsubscribe').then(r => {
//                                 $analytics.track('Click cancel');
//                                 aTrackClick('membership_unsubscribe');
//                                 if(info.payment_method)
//                                     new PauseDialog(r, true).present().then($location.reload);
//                                 else
//                                     new CancelDialog(r).present().then($location.reload);
//                             }))
//                     })
//                 ]);
//             } else {
//                 let text: string;
//                 if(has_current_subscription)
//                     text = yInterpolate($i18n.tl.t_membership_pauses, $time(info.subscription!.end_date).format('d MMM yyyy'));
//                 else
//                     text = yInterpolate($i18n.tl.t_membership_paused, next_payment.format('d MMM yyyy'));

//                 left_col.ui_add($el.DIV('tl-membership-box l-form', [
//                     $el.P('text', text),
//                     $el.DIV('l-button-row m-left', [
//                         new UIButton({
//                             title: $i18n.tl.b_resume_now, classes: 'ui-tint-reverse', on_click: () =>
//                                 uiLock(meAction('unpause').then(r => {
//                                     if(r === true) {
//                                         $location.reload();
//                                     } else {
//                                         new ABPaymentDialog(r, {
//                                             finish: (model: CLoginUser) => {
//                                                 Object.assign(the_user!, model);
//                                                 $location.reload();
//                                             }
//                                         }, { title: $i18n.tl.b_change_payment }).present();
//                                     }
//                                 }))
//                         }),
//                         !has_current_subscription && next_payment.add(-14, $time.day).is_past && new UIButton({
//                             title: $i18n.tl.b_extend_pause, classes: 'ui-tint-reverse', on_click: () => {
//                                 new ExtendPauseDialog(next_payment).present().then($location.reload);
//                             }
//                         })
//                     ]),
//                     $el.DIV('l-button-row m-left', [
//                         new UIButton({
//                             title: $i18n.tl.b_unsubscribe, classes: 'ui-tint-reverse', on_click: () => {
//                                 new CancelPauseDialog().present().then($location.reload);
//                             }
//                         })
//                     ])
//                 ]));
//             }
//         }

//         const gc_code = new UITextInput({ placeholder: $i18n.tl.ph_gc_code, autofill: 'giftcard-code' });

//         left_col.ui_add([
//             $el.DIV('s-medium'),
//             $el.H3('heading', $i18n.tl.h_membership_have_gc),
//             gc_code,
//             $el.DIV('l-button-row m-left', [
//                 new UIButton({
//                     title: $i18n.tl.b_enter_gc, classes: 'ui-tint-reverse', on_click: () =>
//                         meAction('redeem_gc', { code: gc_code.value }).then($location.reload, uiToast)
//                 })
//             ])
//         ]);

//         section.ui_add($el.DIV('l-columns w-block', [left_col, right_col]));

//         const transactions = info.transactions.filter(e => e.type != 'redeem');

//         if(transactions.length) {
//             transactions.sort((a, b) => $time.compare($time(b.date), $time(a.date)));

//             // TODO: fix for payment/refund combos
//             const def = new UITableDefinition<EUserTransactionHomeView>();
//             def.addValue(e => {
//                 const date = $time(e.date);
//                 let text = date.format('d MMM yyyy');
//                 if(e.payment_failed)
//                     text += ' (' + $i18n.tl.td_payment_failed + ')';
//                 if(e.refund_transaction_id)
//                     text += ' (' + $i18n.tl.td_payment_refund + ')';
//                 return text;
//             }, { title: $i18n.tl.th_payment_date, width: 150, comparator: (a, b, o) => o * $time.compare($time(a.date), $time(b.date)) });
//             def.addValue(makeTransactionDescription, { title: $i18n.tl.th_payment_description, width: 200, classes: 'm-pre' });
//             def.addValue(e => e.payment_method ? eLegacyPaymentMethodDescription(e.payment_method) : '-', { title: $i18n.tl.th_payment_method, width: 160 });
//             def.addValue(e => e.refund_transaction_id ? $amount.neg(e.amount) : e.amount, $fmt.CURRENCY, { title: $i18n.tl.th_payment_total, width: 80 });
//             def.addButtons([
//                 {
//                     icon: UIIcon.PAPERCLIP, tooltip: $i18n.tl.b_payment_receipt, when: e => !e.refund_transaction_id && !e.payment_failed,
//                     link: e => ({
//                         href: `/docs/user/${the_user!.id}/receipt/${e.id}?format=pdf&token=${the_alt_token}`,
//                         download: 'Abundo kvitto - ' + $time(e.date).format('yyyy-MM-dd') + '.pdf'
//                     })
//                 }
//             ], { width: -30 });

//             def.controller = row => {
//                 row.classList.add('tl-payment-info-row');
//                 if(row.item.payment_failed)
//                     row.classList.add('m-failed');

//                 return undefined;
//             }

//             const invite = new UIButton({
//                 kind: 'k-text', classes: 'm-inline', title: $i18n.tl.b_invite_friends_here,
//                 on_click: () => { $location.navigate(['invite']) }
//             });

//             section.ui_add($el.DIV('w-block-1200 l-form', [
//                 $el.DIV('s-medium'),
//                 $el.H3('heading', $i18n.tl.h_payment_history),
//                 new UITable(def, new YArrayDataSource(transactions)),
//                 $el.P('text', [$i18n.tl.p_payment_history_bonus + ' ', invite], 'r-invite')
//             ]));
//         }
//     }
// }
